import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import PostCard from "../components/PostCard";
import {
  getPostBySlug, getPostsByCategory, getCategoryName,
} from "../data/posts";
import NotFound from "./NotFound";
import { getPostImage } from "../data/postImages";

function Block({ b }) {
  if (b.type === "h2") return <h2>{b.text}</h2>;
  if (b.type === "p") return <p>{b.text}</p>;
  if (b.type === "ul")
    return (
      <ul>
        {b.items.map((it, i) => <li key={i}>{it}</li>)}
      </ul>
    );
  if (b.type === "div")
    return <div className={b.className}>{b.text}</div>;
  return null;
}

function PostDetail() {
  const { slug } = useParams();
  const post = getPostBySlug(slug);

  if (!post) return <NotFound />;

  const related = getPostsByCategory(post.category)
    .filter((p) => p.slug !== post.slug)
    .slice(0, 3);

  const heroImage = getPostImage(post);

  return (
    <Container className="py-4">
      <Breadcrumb listProps={{ className: "small mb-3" }}>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
        <Breadcrumb.Item linkAs={Link} linkProps={{ to: `/category/${post.category}` }}>
          {getCategoryName(post.category)}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{post.title}</Breadcrumb.Item>
      </Breadcrumb>

      <Row className="g-4">
        <Col lg={8}>
          <article className="article" style={{ borderTopColor: post.color }}>
            {heroImage && (
              <img
                src={heroImage}
                alt={post.title}
                className="article-feature-img"
              />
            )}
            <div className="article-inner">
              {/* <Link
                to={`/category/${post.category}`}
                className="post-cat-badge mb-3"
                style={{ background: post.color, color: "#fff" }}
              >
                {getCategoryName(post.category)}
              </Link> */}
              <h1>{post.title}</h1>

              {/* <div className="post-meta mb-4">
                <span className="mi"><FaUser /> {post.author}</span>
                <span className="mi"><FaRegClock /> {post.date}</span>
                <span className="mi">
                  <FaFolder />{" "}
                  <Link to={`/category/${post.category}`}>{getCategoryName(post.category)}</Link>
                </span>
                <span className="mi"><FaRegComment /> {post.comments} Comments</span>
              </div> */}

              {post.body.map((b, i) => <Block key={i} b={b} />)}

              <div className="info-box">
                <strong>Disclaimer:</strong> APK Downloads is an information blog.
                We do not host any APK or copyrighted files. Always download apps
                from the official Google Play Store or the developer's website.
              </div>

              <div className="mt-3">
                <strong className="d-block mb-2">Tags:</strong>
                {post.tags.map((t) => (
                  <Link key={t} to={`/search?q=${t}`} className="tag-pill">#{t}</Link>
                ))}
              </div>
            </div>
          </article>

          {/* Related posts */}
          {related.length > 0 && (
            <>
              <h2 className="block-title mt-5">Related Posts</h2>
              <Row className="g-4">
                {related.map((p) => (
                  <Col md={4} key={p.id}>
                    <PostCard post={p} />
                  </Col>
                ))}
              </Row>
            </>
          )}
        </Col>

        <Col lg={4}>
          <Sidebar />
        </Col>
      </Row>
    </Container>
  );
}

export default PostDetail;
